import { MoreVert } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useCallback, useState } from 'react';
import { Order } from '../../../apiTypes';
import PrimaryButton, { PrimaryButtonProps } from '../../../components/PrimaryButton';
import { useCafe } from '../../../contexts/cafe.context';
import EditDeliveryOrderModal from './EditDeliveryOrderModal';

type Props = PrimaryButtonProps & {
  order?: DbDocument<Order>;
};

const EditDeliveryOrderButton = (props: Props) => {
  const { order, ...rest } = props;

  const { worker } = useCafe();
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <>
      {!order && (
        <PrimaryButton
          {...rest}
          onClick={() => setIsOpen(true)}
          disabled={!worker?.credentials.create_and_edit_own_orders}
        />
      )}

      {order && (
        <IconButton onClick={() => setIsOpen(true)}>
          <MoreVert />
        </IconButton>
      )}

      {isOpen && <EditDeliveryOrderModal onClose={handleClose} order={order} />}
    </>
  );
};

export default EditDeliveryOrderButton;
